<script>
	import { cn } from "./cn.js";

	export let variant = "default"; // default | secondary | required | optional | outline
	let className = "";
	export { className as class };

	const variants = {
		default: "tw-bg-primary tw-text-primary-foreground",
		secondary: "tw-bg-secondary tw-text-secondary-foreground",
		required: "tw-bg-destructive/10 tw-text-destructive",
		optional: "tw-bg-muted tw-text-muted-foreground",
		outline: "tw-border tw-border-border tw-text-foreground",
	};
</script>

<span
	class={cn(
		"tw-inline-flex tw-items-center tw-rounded-full tw-px-2 tw-py-0.5 tw-text-xs tw-font-medium",
		variants[variant],
		className,
	)}
>
	<slot />
</span>
